"use client";

import {
  ticketTotalsRows,
  type CanonicalTicketTotals,
} from "./event-ticket-public-controller";

export function EventTicketTotals({ totals }: { totals: CanonicalTicketTotals }) {
  return (
    <dl className="space-y-2 border-y border-border py-4 text-sm text-muted-foreground">
      {ticketTotalsRows(totals).map(([label, value], index) => (
        <div
          key={label}
          className={`flex justify-between gap-4 ${index === 2 ? "pt-2 text-base font-semibold text-foreground" : ""}`}
        >
          <dt>{label}</dt>
          <dd>{value}</dd>
        </div>
      ))}
    </dl>
  );
}
